import ReportBounds from "./ReportBounds";
import ReportEventStatistics from "./ReportEventStatistics";

class TrackingSummaryReportData {
    constructor({reportBoundsParams, /*:ReportBounds */ accessDeniedStatus /*:string */}) {
        this._reportPeriod = new ReportBounds(reportBoundsParams);
        this._reportedEvents = [];
        this._reportStats = new ReportEventStatistics(accessDeniedStatus);
    }

    get reportBounds() /* returns ReportBounds */ {
        return this._reportPeriod;
    }

    get reportEventStatistics() {
        return this._reportStats;
    }

    get reportedEvents() {
        return this._reportedEvents;
    }

    clearEvents() {
        this._reportedEvents.length = 0;
        this._reportStats.reset();
    }
}

export default TrackingSummaryReportData;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/report-models/TrackingSummaryReportData.js
// module id = nIr4
// module chunks = 1